export const amountPreselectedValues = [20, 50, 100, 500];

export const MAX_AMOUNT = 1_000_000_000_000;
